import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TemplatedText from '../../../components/templated-text';
import type { CustomQuestionsFormData } from '../../../types';
import { previewLabel } from '../../../utils/preview-label';
type DropdownPreviewProps = {
  questionIndex: number;
};
const DropdownPreview = t0 => {
  const $ = _c(31);
  const {
    questionIndex
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.label`;
  const t2 = `questions.${questionIndex}.required`;
  const t3 = `questions.${questionIndex}.options`;
  const t4 = `questions.${questionIndex}.includeOther`;
  const t5 = `questions.${questionIndex}.placeholder`;
  let t6;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = [t1, t2, t3, t4, t5];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== control || $[7] !== t6) {
    t7 = {
      control,
      name: t6
    };
    $[6] = control;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const [label, required, options, includeOther, placeholder] = useWatch(t7);
  let t8;
  if ($[9] !== t) {
    t8 = t(_temp);
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const otherLabel = t8;
  let t9;
  if ($[11] !== t) {
    t9 = trimmed => t(_temp2, {
      label: trimmed
    });
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== label || $[14] !== required || $[15] !== t9) {
    t10 = previewLabel(label, required, t9);
    $[13] = label;
    $[14] = required;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const labelWithOptional = t10;
  let t11;
  if ($[17] !== includeOther || $[18] !== options || $[19] !== otherLabel) {
    t11 = includeOther ? [...(options || []), {
      value: "Other",
      label: otherLabel
    }] : options || [];
    $[17] = includeOther;
    $[18] = options;
    $[19] = otherLabel;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const allOptions = t11;
  let t12;
  if ($[21] !== labelWithOptional) {
    t12 = labelWithOptional && <TemplatedText value={labelWithOptional} />;
    $[21] = labelWithOptional;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = `questions.${questionIndex}.preview` as any;
  let t14;
  if ($[23] !== placeholder || $[24] !== t) {
    t14 = placeholder || t(_temp3);
    $[23] = placeholder;
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== allOptions || $[27] !== t12 || $[28] !== t13 || $[29] !== t14) {
    t15 = <Form.Select label={t12} name={t13} options={allOptions} placeholder={t14} />;
    $[26] = allOptions;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
export default DropdownPreview;
function _temp($) {
  return $.form.otherOption;
}
function _temp2($_0) {
  return $_0.preview.labelOptional;
}
function _temp3($_1) {
  return $_1.preview.selectPlaceholder;
}